<div class="main-content side-content mt-10 ">
    <div class="main-container container-fluid" [formGroup]="DasboardForm">
        <div class="inner-body">
            <div class="page-header">
                <div>
                    <h2 class="main-content-title tx-18 mg-b-5">Dashboard</h2>
                    <ol class="breadcrumb">
                    </ol>
                </div>
            </div>
            <div class="row row-sm">
                <div class="col-sm-12">
                    <div class="row">
                        <div *ngIf="ShowForAvaiReqst" class="col-sm-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="card-item">
                                        <div class="card-item-title mb-2">
                                            <label class="main-content-label tx-13 font-weight-bold mb-1">Request For
                                                Practical Examiner Availability</label>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive">
                                                <table id="datatable" class="table table-bordered text-left dashboard-fixed-table">
                                                    <colgroup>
                                                        <col style="width: 22%;">
                                                        <col style="width: 22%;">
                                                        <col style="width: 18%;">
                                                        <col style="width: 18%;">
                                                        <col style="width: 20%;">
                                                    </colgroup>
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th class="f600">Session </th>
                                                            <th class="f600">Course Name </th>
                                                            <!-- <th class="f600">College Name </th> -->
                                                            <th class="f600">Subject Name </th>
                                                            <th class="f600">Request Type </th>
                                                            <th class="f600">Availability </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data">
                                                        <tr *ngFor="let tdata of TeacherAvailiData;">
                                                            <td class="wrap-cell"> {{ getSessionName(tdata) }}</td>
                                                            <td class="wrap-cell"> {{tdata.CoName}}</td>
                                                            <!-- <td class="wrap-cell"> {{tdata.CgName}}</td> -->
                                                            <td class="wrap-cell"> {{tdata.EsName}}</td>
                                                            <td class="wrap-cell"> {{tdata.ReqType}}</td>
                                                            <td *ngIf="AvaiDisabled2"
                                                                class="wrap-cell"
                                                                style="text-decoration: underline;color: blue; cursor: pointer;"
                                                                (click)="submitStatus(tdata,'Availability')">
                                                                Click Here
                                                            </td>
                                                            <td *ngIf="AvaiDisabled" class="wrap-cell">
                                                                {{ tdata.Availability == 1 ? 'Available' : 'Not Available'
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="ShowForTeacher && showAss" class="col-sm-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="card-item">
                                        <div class="card-item-title mb-2">
                                            <label class="main-content-label tx-13 font-weight-bold mb-1">
                                                Request For Examiner Assignment <span *ngIf="showAss" class="text-muted" style="font-size: 12px;">(For examiners with the Chairperson role, the option for marks entry is available.)</span></label>

                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive">
                                                <table id="datatable" class="table table-bordered text-left dashboard-fixed-table">
                                                    <colgroup>
                                                        <col style="width: 10%;">
                                                        <col style="width: 12%;">
                                                        <col style="width: 14%;">
                                                        <col style="width: 13%;">
                                                        <col style="width: 10%;">
                                                        <col style="width: 10%;">
                                                        <col style="width: 13%;">
                                                        <col style="width: 18%;">
                                                    </colgroup>
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th class="f600">Session </th>
                                                            <th class="f600">Course Name </th>
                                                            <!-- <th class="f600">College Name </th> -->
                                                            <th class="f600">Subject Name </th>
                                                            <th class="f600">Assigned College Name </th>
                                                            <th class="f600">Assigned For </th>
                                                            <th class="f600">Action </th>
                                                            <th class="f600">Report </th>
                                                            <th class="f600" style="white-space: nowrap;">Practical Marks Entry </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data">
                                                        <tr *ngFor="let tdata of TeacherAssignData;">
                                                            <td class="wrap-cell"> {{ getSessionName(tdata) }}</td>
                                                            <td class="wrap-cell"> {{tdata.CoName}}</td>
                                                            <!-- <td class="wrap-cell"> {{tdata.CgName}}</td> -->
                                                            <td class="wrap-cell"> {{tdata.EsName}}</td>
                                                            <td class="wrap-cell"> {{tdata.AssignedCollege}}</td>
                                                            <td class="wrap-cell"> {{tdata.AssignedAs}}</td>

                                                            <td *ngIf="tdata.AcceptStatus === -1 || tdata.AcceptStatus === 0"
                                                                class="wrap-cell"
                                                                style="text-decoration: underline; color: blue; cursor: pointer;"
                                                                (click)="submitStatus(tdata,'Examiner')">
                                                                Click Here
                                                            </td>
                                                            <td *ngIf="tdata.AcceptStatus === 1" class="wrap-cell">
                                                                {{ tdata.AcceptStatus === 1 ? 'Accepted' : 'Rejected' }}
                                                            </td>
                                                            <td *ngIf="tdata.AcceptStatus === 1" class="wrap-cell">
                                                                <a href="javascript:void(0)" (click)="Print(tdata)">
                                                                    Appointment Letter
                                                                </a>
                                                            </td>
                                                            <td *ngIf="tdata.AcceptStatus === 1" class="wrap-cell text-center">
                                                                <button *ngIf="canShowPracMarkEntry(tdata)"
                                                                        type="button"
                                                                        class="btn btn-sm btn-success pme-btn"
                                                                        title="Practical Marks Entry"
                                                                        (click)="goToPracticalMarkEntry(tdata)">
                                                                    <i class="fas fa-edit"></i>
                                                                    <span>Marks Entry</span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- ================= NO ASSIGNMENT CARD ================= -->
                        <div *ngIf="ShowForTeacher && !showAss" class="col-sm-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="card-item">
                                        <div class="card-item-icon">

                                        </div>
                                        <div class="card-item-title mb-2">
                                            <label class="main-content-label tx-13 font-weight-bold mb-1">Examiner
                                                Assignment</label>
                                        </div>
                                        <div class="card-item-body">
                                            <div class="card-item-stat">
                                                <h6 style="color: red;" class="font-weight-bold">You are not assigned to
                                                    the current session.</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- ================= THEORY EXAM APPOINTMENTS ================= -->
                        <div *ngIf="ShowForTeacher && showTheoryExamAppointments && theoryExamAppointments.length > 0" class="col-sm-12 mt-4">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="card-item">
                                        <div class="card-item-title mb-2">
                                            <label class="main-content-label tx-13 font-weight-bold mb-1">
                                                Theory Exam Appointments
                                            </label>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered text-left mb-0">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th style="min-width: 100px;">Session</th>
                                                            <th style="min-width: 80px;">Role</th>
                                                            <th *ngIf="showDateColumns" style="min-width: 100px;">From Date</th>
                                                            <th *ngIf="showDateColumns" style="min-width: 100px;">To Date</th>
                                                            <th style="min-width: 120px;">Faculty</th>
                                                            <th style="min-width: 150px;">Course</th>
                                                            <th style="min-width: 150px;">Exam</th>
                                                            <th style="min-width: 120px;">Center</th>
                                                            <th style="min-width: 120px;">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let item of theoryExamAppointments">
                                                            <td>{{ getSessionName(item) }}</td>
                                                            <!-- <td>{{ item.RoleName }}</td> -->
                                                            <td>{{ item.RoleCode === 'C' ? 'Custodian' : item.RoleName }}</td>
                                                            <td *ngIf="showDateColumns">{{ item.FromDate || '-' }}</td>
                                                            <td *ngIf="showDateColumns">{{ item.ToDate || '-' }}</td>
                                                            <td>{{ item.FacultyName || '-' }}</td>
                                                            <td>{{ item.CourseName || '-' }}</td>
                                                            <td>{{ item.ExamName || '-' }}</td>
                                                            <td>{{ item.CenterName || '-' }}</td>
                                                            <td class="text-center">
                                                                <button type="button"
                                                                        class="btn btn-sm btn-primary"
                                                                        style="white-space: nowrap;"
                                                                        (click)="viewAppointmentLetter(item)">
                                                                    <i class="fas fa-file-alt"></i> View Letter
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>